import type { TMessages } from '@/types/TMessages'

export const formMessages = {
  comment: 'Из раздела продажи урожая',
} satisfies TMessages
